<template>
    <div class="model-wrap">
        <BigPreloader
            v-if="appIsLoading"
            :caption="$t('model.model.preloader.caption')"
            :info="$t('model.model.preloader.info')"
        />
        <nlu-model
            v-else-if="isNluModel"
        />
        <external-model
            v-else-if="isCustomModel"
        />
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import NluModel from './nlu-model/nlu-model'
import ExternalModel from './external-model/external-model'
import BigPreloader from '@/components/common/BigPreloader'

export default {
  components: {
    NluModel,
    ExternalModel,
    BigPreloader
  },

  created () {
    if (!this.appIsLoading) {
      this.initModel()
    }
  },

  computed: {
    ...mapState('knowledgebase', ['appIsLoading', 'knowledgeBases']),
    ...mapState('knowledgebase/customModels', ['customModels']),
    ...mapGetters('knowledgebase', ['getCurrent'])
  },

  data () {
    return {
      isNluModel: false,
      isCustomModel: false
    }
  },

  methods: {
    ...mapActions('knowledgebase', ['initNluModel']),
    ...mapActions('knowledgebase/customModels', ['initCustomModel']),

    initModel () {
      const modelId = _.get(this.$router, 'currentRoute.params.id', null)

      if (_.find(this.knowledgeBases, ['id', modelId])) {
        this.initNluModel(modelId)
        this.isNluModel = true
      } else if (_.find(this.customModels, ['id', modelId])) {
        this.initCustomModel({ id: modelId })
        this.isCustomModel = true
      } else {
        this.$router.push({ name: 'not-found' })
      }
    }
  },

  watch: {
    appIsLoading (value, prev) {
      if (!value && prev) {
        this.initModel()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
    .model-wrap {
        display: flex;
        position: relative;
        flex-direction: column;
        width: 100%;
        // height: 100%;
        height: calc(100% - 78px);
    }
</style>
